import first from 'lodash/first'
import type { FunctionComponent } from 'react'
import 'twin.macro'
import type { BlockThreeColumnFragment } from '../../../investors-graphql/generated/graphql'
import { ChildrenBlockSpacingContainer } from '../contentful/ChildrenBlockSpacingContainer'
import { ContentfulBlocks } from '../contentful/ContentfulBlocks'
import type { QueryAllBlocksRecursivelyResult } from '../contentful/QueryAllBlocksRecursivelyResult'
import AnalystRatings from './AnalystRatings/AnalystRatings'
import { getBlockChildren } from './block.utils'

export const ThreeColumnLayout: FunctionComponent<React.PropsWithChildren<{
  block: QueryAllBlocksRecursivelyResult<BlockThreeColumnFragment>
}>> = ({ block }) => {
  // TODO: WIP
  const showArrow =
    (first(block.leftColumnCollection?.items) as any)?.__typename ===
    'BlockAnalystRating'

  if (showArrow) {
    return (
      <AnalystRatings
        blocks={getBlockChildren(block, [
          ...(block.leftColumnCollection?.items ?? []),
          ...(block.middleColumnCollection?.items ?? []),
          ...(block.rightColumnCollection?.items ?? []),
        ])}
      />
    )
  }

  return (
    <div tw="grid grid-cols-1 md:grid-cols-3 gap-px-48">
      <ChildrenBlockSpacingContainer>
        <ContentfulBlocks
          blocks={getBlockChildren(block, block.leftColumnCollection?.items)}
        />
      </ChildrenBlockSpacingContainer>
      <ChildrenBlockSpacingContainer>
        <ContentfulBlocks
          blocks={getBlockChildren(block, block.middleColumnCollection?.items)}
        />
      </ChildrenBlockSpacingContainer>
      <ChildrenBlockSpacingContainer>
        <ContentfulBlocks
          blocks={getBlockChildren(block, block.rightColumnCollection?.items)}
        />
      </ChildrenBlockSpacingContainer>
    </div>
  )
}
